<script setup></script>

<template>
  <div class="dash-flex dash-flex-col dash-gap-6 dash-w-full dash-h-full">
    <slot name="header" />
    <slot name="content" />
    <slot name="footer" />
  </div>
</template>
